import React, { useState } from 'react'
import { StyledPinSpan } from './Pin.styled'
import { ReactComponent as PinSVG } from './pin.svg'

interface IStyledPin {
  isPinned: boolean
  onClick: (e: React.MouseEvent<HTMLInputElement>) => void
  isTODetails?: boolean
}

export function StyledPin({ isPinned, onClick, isTODetails }: IStyledPin) {
  const [innerPinned, setInnerPinned] = useState(isPinned)

  function wrappedOnCLick(e: React.MouseEvent<HTMLInputElement, MouseEvent>) {
    onClick(e)
    if (innerPinned) {
      setInnerPinned(!innerPinned)
    }
  }

  return (
    <StyledPinSpan onClick={wrappedOnCLick} isPinned={innerPinned} isTODetails={isTODetails}>
      <PinSVG />
    </StyledPinSpan>
  )
}
